module.exports = __webpack_public_path__ + "static/media/gray_05.930de606.jpg";